<template>
  <v-container class="submission-form" id="submission-form">
    <v-row>
      <v-col cols="6" class="form-header">
        <h2>Registrant information</h2>
      </v-col>
    </v-row>
    <v-divider class="mb-7" />
    <a id="start" style="visibility: none;" />
    <v-form  ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col>
          <h3>Contact person</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <p>Register as an investor, buyer, or interested counter-party to review curated opportunities in Africa</p>
          <v-text-field
            v-model="contactPerson.givenName"
            label="Given Name"
            filled
            :rules="rules.required"
          ></v-text-field>
          <v-text-field
            v-model="contactPerson.familyName"
            label="Family Name"
            filled
            :rules="rules.required"
          ></v-text-field>
          <v-text-field
            v-model="contactPerson.email"
            label="Email address"
            filled
            :rules="rules.required.concat(rules.email)"
          ></v-text-field>
          <v-text-field
            v-model="contactPerson.telephone"
            label="Phone number"
            filled
            :rules="rules.required.concat(rules.phone)"
          ></v-text-field>
          <v-text-field
            v-model="contactPerson.password"
            label="Password"
            filled
            type="password"
            autocomplete="new-password"
            :rules="rules.required.concat(rules.password)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5" lg="4" offset-md="1">
          <investor-banner />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h3>Company</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="company.name"
            label="Company Name"
            filled
            :rules="rules.required"
          ></v-text-field>
          <v-text-field
            v-model="company.website"
            label="Website"
            filled
            :rules="rules.required"
          ></v-text-field>
          <v-select
            :items="options.countries"
            v-model="company.baseCountry"
            filled
            label="Home country"
            item-text="label"
            item-value="label"
            :rules="rules.required"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <p class="group-title">How investor or counterparty meets U.S. Nexus requirements</p>
          <p class="caption">Check all that apply</p>
          <div class="nexus">
            <v-checkbox
              v-for="item in options.nexus"
              :key="item.value"
              v-model="submission.other.nexus"
              :label="item.name"
              :value="item.value"
              hide-details="auto"
            ></v-checkbox>
            <v-textarea
              v-if="submission.other.nexus.includes('other')"
              filled
              rows="3"
              auto-grow
              hide-details="auto"
              v-model="submission.other.nexusReason"
              label="Describe how meet U.S. nexus requirement"
            ></v-textarea>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h3 class="mb-10">Trade and investment interests</h3>
          <h5>Type of transaction</h5>
          <v-radio-group v-model="submission.other.transactionType" row>
            <v-radio
              v-for="option in options.transactionType"
              :key="option.name"
              :label="option.name"
              :value="option.value"
              color="#18305A"
              ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0">
          <h5>Sectors of interest</h5>
          <p class="caption">Check all that apply</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0">
          <v-checkbox
            v-model="allSectors"
            label="All industries"
            @change="toggleCheckboxes('industrySectors')"
            class="main-checkbox"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
          <v-checkbox
            v-for="item in options.industrySectors.slice(0, options.industrySectors.length / 3)"
            :key="item.value"
            v-model="submission.industrySectors"
            :label="item.name"
            :value="item.name"
            @change="checkAll('industrySectors')"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4">
          <v-checkbox
            v-for="item in options.industrySectors.slice(options.industrySectors.length / 3, (options.industrySectors.length / 3) * 2)"
            :key="item.value"
            v-model="submission.industrySectors"
            :label="item.name"
            :value="item.name"
            @change="checkAll('industrySectors')"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4">
          <v-checkbox
            v-for="item in options.industrySectors.slice((options.industrySectors.length / 3) * 2)"
            :key="item.value"
            v-model="submission.industrySectors"
            :label="item.name"
            :value="item.name"
            @change="checkAll('industrySectors')"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h5>Regional focus</h5>
        </v-col>
      </v-row>
      <v-row align="start">
        <v-col cols="12" sm="auto">
          <v-checkbox
            v-model="allRegions"
            label="All regions"
            @change="toggleCheckboxes('regionalFocus')"
            class="main-checkbox"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col
          v-for="item in options.regionalFocus"
          :key="item.value"
          cols="12" sm="auto">
          <v-checkbox
            v-model="submission.regionalFocus"
            :label="item.name"
            :value="item.value"
            @change="checkAll('regionalFocus')"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h5>Deal size</h5>
        </v-col>
      </v-row>
      <v-row align="start">
        <v-col cols="12" sm="auto">
          <v-checkbox
            v-model="allDealValues"
            label="All ranges"
            @change="toggleCheckboxes('dealRanges')"
            class="main-checkbox"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col
          v-for="item in options.dealRanges"
          :key="item.value"
          cols="12" sm="auto">
          <v-checkbox
            v-model="submission.dealRanges"
            :label="item.name"
            :value="item.value"
            @change="checkAll('dealRanges')"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h5>Deal structure</h5>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-radio-group v-model="submission.dealStructure" row>
            <v-radio
              v-for="option in options.dealStructure"
              :key="option.name"
              :label="option.name"
              :value="option.name"
              ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="submit-block">
        <v-col cols="12" md="8">
          <div class="submit-button-wrap">
            <v-btn
              @click="submit"
              :disabled="isLoading"
              x-large
              color="#f0b323">
              Submit Interest →
            </v-btn>
            <p class="login">Already registered? <a @click="showLogin">SIGN IN →</a></p>
          </div>
          <span class="privacy">We take your
            <router-link ref="link" to="terms" class="big-link">
              privacy
            </router-link>
            very seriously</span>
        </v-col>
        <v-col align-self="center" cols="12" md="4">
          <p class="caption">This platform will continue to be upgraded and improved over time.</p>
          <p class="caption">If you're registered we notify you about major updates.</p>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar timeout="3500" v-model="isMessage">
      {{ messageText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import _ from 'lodash'
import options from '@/data/options'
import appConfig from '@/config/app.config'
import InvestorBanner from '@/components/submission/investor-banner'

const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const phoneRegexp = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/

export default {
  name: 'submission-form',
  components: {
    InvestorBanner
  },
  data () {
    return {
      valid: true,
      options,
      rules: {
        required: [
          value => !!value || 'Required'
        ],
        email: [
          value => !!value.match(emailRegexp) || 'Please enter email, e.g john.doe@example.com'
        ],
        phone: [
          value => !!value.match(phoneRegexp) || 'Please enter valid phone number'
        ],
        password: [
          value => value.length >= 8 || 'Minimum 8 characters'
        ]
      },
      isLoading: false,
      errorMessage: '',
      company: {
        name: '',
        website: '',
        baseCountry: ''
      },
      contactPerson: {
        givenName: '',
        familyName: '',
        email: '',
        telephone: '',
        password: ''
      },
      submission: {
        industrySectors: [],
        regionalFocus: [],
        dealRanges: [],
        dealStructure: undefined,
        other: {
          nexus: [],
          nexusReason: '',
          transactionType: []
        }
      },
      allSectors: false,
      allRegions: false,
      allDealValues: false,
      isMessage: false,
      messageText: ''
    }
  },
  computed: {
  },
  methods: {
    submit () {
      const valid = this.$refs.form.validate()
      if (!valid) {
        location.hash = ''
        this.messageText = 'Please correct validation errors above'
        this.isMessage = true
        location.hash = 'start'
        return
      }

      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'submit-investor-form',
        eventLabel: 'Submit investor form'
      })

      this.isLoading = true
      this.errorMessage = ''

      const payload = Object.assign({}, {
        ...this.submission,
        company: this.company,
        contactPerson: this.contactPerson
      })

      if (!payload.dealStructure) {
        delete payload.dealStructure
      }

      payload.platform = 'crossboundary'
      payload.investorType = 'private'

      if (this.allSectors) {
        payload.industrySectors = ['all'].concat(payload.industrySectors)
      }
      if (this.allRegions) {
        payload.regionalFocus = ['all'].concat(payload.regionalFocus)
      }
      if (this.allDealValues) {
        payload.dealRanges = ['all'].concat(payload.dealRanges)
      }

      const recaptcha = appConfig.recaptchaValidResponse
      const displayName = `${this.contactPerson.givenName} ${this.contactPerson.familyName}`
      const userName = displayName.toLowerCase()

      const newUser = {
        email: this.contactPerson.email,
        password: this.contactPerson.password,
        firstName: this.contactPerson.givenName,
        familyName: this.contactPerson.familyName,
        displayName,
        username: userName,
        confirmemail: this.contactPerson.email,
        organisation: this.company.name,
        sector: 'Investment - Private Equity',
        userType: 'crossboundary user',
        acceptTerms: true,
        recaptcha
      }

      newUser.data = { ...newUser.data }
      return this.$store.dispatch('user/register', { userData: newUser, interest: payload }).then(() => {
        this.$emit('submitted')
        this.isLoading = false
        setTimeout(() => {
          this.$router.push('/deals')
        }, 3500)
      }).catch((err) => {
        this.isLoading = false
        const message = _.get(err, 'response.data.message') || err.message || err
        const status = _.get(err, 'response.data.statusCode')
        if (status === 403) {
          const instruction = `${message} Please sign in to your existing account, or try a different email address to register.`
          return this.$store.dispatch('modals/showError', instruction, { root: true })
        }
        this.$store.dispatch('modals/showError', message, { root: true })
      })
    },
    toggleCheckboxes (name) {
      if (name === 'industrySectors') {
        if (this.allSectors) {
          this.submission.industrySectors = options.industrySectors.map(item => item.name)
        } else {
          this.submission.industrySectors = []
        }
      }
      if (name === 'regionalFocus') {
        if (this.allRegions) {
          this.submission.regionalFocus = options.regionalFocus.map(item => item.value)
        } else {
          this.submission.regionalFocus = []
        }
      }
      if (name === 'dealRanges') {
        if (this.allDealValues) {
          this.submission.dealRanges = options.dealRanges.map(item => item.value)
        } else {
          this.submission.dealRanges = []
        }
      }
    },
    checkAll (name) {
      if (name === 'industrySectors') {
        if (this.submission.industrySectors.length === this.options.industrySectors.length) {
          this.allSectors = true
        } else {
          this.allSectors = false
        }
      }
      if (name === 'regionalFocus') {
        if (this.submission.regionalFocus.length === this.options.regionalFocus.length) {
          this.allRegions = true
        } else {
          this.allRegions = false
        }
      }
      if (name === 'dealRanges') {
        if (this.submission.dealRanges.length === this.options.dealRanges.length) {
          this.allDealValues = true
        } else {
          this.allDealValues = false
        }
      }
    },
    showLogin () {
      this.$store.dispatch('modals/showModal', 'login')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.submission-form {
  padding-top: 100px;
}
.form-header {
  color: $gray-primary;
  h2 {
    font-weight: bold;
    font-size: 36px;
    line-height: 120%;
    font-family: $header-font;
    margin-bottom: 20px;
  }
}
h3 {
  color: $text-primary;
  font-family: $header-font;
  font-size: 20px;
  line-height: 140%;
  font-weight: 500;
}
h5 {
  color: $text-primary;
  font-family: $header-font;
  font-size: 12px;
  font-weight: 600;
  line-height: 130%;
  text-transform: uppercase;
}
.v-input--checkbox {
  margin-top: 0px;
}
.v-text-field {
  & ::v-deep .v-text-field__details {
    display: block;
  }
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 5px!important;
}
.v-input {
  .v-label {
    line-height: 27px!important;
    font-size: 18px;
    color: #93979D;
  }
}
.main-checkbox {
  & ::v-deep label {
    font-weight: bold;
  }
}
.group-title {
  color: $gray-primary;
  font-size: 18px;
  line-height: 150%;
  margin-bottom: 0px;
}
.caption {
  color: #93979D;
}
.submit-block {
  background: rgb(255,251,243);
  padding-top: 15px;
  padding-bottom: 35px;
  margin-left: -10%;
  padding-left: 10%;
  .privacy {
    color:#002f6c;
    font-family: $header-font;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    text-transform: uppercase;
    opacity: 0.8;
    display: block;
    margin-top: 40px;
    @media (min-width: 768px) {
      margin-top: 0px;
      margin-left: 20px;
      display: inline-block;
    }
    a {
      color: #002f6c;
    }
  }
  .caption {
    margin-bottom: 0px;
  }
}
.v-text-field__slot {
  &::before {
    bottom: 0;
  }
}
.nexus {
  .v-input {
    margin: 10px 0;
  }
}
.submit-button-wrap {
  display: inline-block;
  position: relative;
  .login {
    position: absolute;
    bottom: -45px;
    left: 15px;
    color: #002f6c;
    font-size: 14px;
    a {
      font-weight: bold;
      color: #002f6c;
    }
  }
}
</style>
